import React from 'react';
import { ListGroupItem, Badge } from 'reactstrap';

export type ListItemProps = {
  linkId: string;
  text: string;
  active?: boolean;
  enabled?: boolean;
  disabled: boolean;
  complete?: boolean;
  error?: boolean;
  onClick?: React.MouseEventHandler;
};
const ListItemBadge = ({ error, complete }: ListItemProps) =>
  error || complete ? (
    <Badge>{error ? 'Error' : complete ? 'Done' : ''}</Badge>
  ) : null;
const ListItem = (props: ListItemProps) =>
  props.enabled === undefined || props.enabled ? (
    <ListGroupItem
      action
      active={!props.error && props.active}
      tag={'button'}
      className="justify-content-between"
      color={props.error ? 'danger' : props.complete ? 'success' : undefined}
      onClick={props.onClick}
      disabled={props.disabled}>
      {props.text} <ListItemBadge {...props} />
    </ListGroupItem>
  ) : null;

export default ListItem;
